import type {ColumnFragment, ValueFragment} from "app/gql/graphqlSchema";
import {DisplayOption} from "app/employee/controlCard/display/DisplayOption";

interface Props {
  column: ColumnFragment & {__typename: "ControlCardChoiceColumn"};
  value: ValueFragment;
}

export const DisplayChoice = ({column, value}: Props) => {
  return <DisplayOption options={column.options} value={value} />;
};
